import styled from 'styled-components';
import { Input, NumberInput } from 'react-inv-forms';
import { Form } from 'antd';
import { variables } from '../../../../styles/variables';

const { Item } = Form;

const CustomInput = styled(Input)`
  font-size: 1.6rem;
  padding: 1px 6px;
  margin: 0;
  &.ant-input-affix-wrapper-focused {
    border-color: ${variables.colorDecorator};
    box-shadow: 0 0 0 2px rgba(139,35,29, 0.1);
  }
  &:hover:not(.ant-input-affix-wrapper-disabled) {
    border-color: ${variables.colorDecorator};
  }
  input {
    color: ${variables.colorMainText};
  }
`;

const CustomNumberInput = styled(NumberInput)`
  font-size: 1.6rem;
  padding: 0 2px;
  margin: 0;
  width: 50px;
  border: 1px solid ${variables.colorBorder};
  &.ant-input-number-focused {
    border: none;
    box-shadow: none;
  }
  input.ant-input-number-input {
    padding: 0;
  }
  .ant-input-number-handler:hover .ant-input-number-handler-up-inner, 
  .ant-input-number-handler:hover .ant-input-number-handler-down-inner {
    color: ${variables.colorDecorator};
  }
`;

const CustomItem = styled(Item)`
  margin: 0;
  position: relative;
  padding: 0;
  display: inline-block;
  width: 90%;
  .ant-form-item-explain {
    position: absolute;
    font-size: 1.2rem;
    line-height: 1.2rem;
    opacity: 0.8;
    bottom: -30px;
    width: max-content;
  }
`;

export {
  CustomInput as Input,
  CustomItem as Item,
  CustomNumberInput as NumberInput,
};